import React from 'react';
import rankBg from '@/common-pages/leaderboard/assets/daily-rank-bg.webp';
import priceIcon from '../../assets/daily-price.webp';
import bounsIcon from '../../assets/daily-bouns.webp';
import defaultUser from '@/common-pages/leaderboard/assets/user-default-2.svg';
import {Image} from 'antd-mobile';
import rankbg1 from '../../assets/rank-bg-1.webp';
import rankbg2 from '../../assets/rank-bg-2.webp';
import rankbg3 from '../../assets/rank-bg-3.webp';
import rank1 from '../../assets/rank-icon-1.webp';
import rank2 from '../../assets/rank-icon-2.webp';
import rank3 from '../../assets/rank-icon-3.webp';
import {toPriceStr} from '@components/utils';

const rankbgList = [rankbg1, rankbg2, rankbg3];
const rankIconList = [rank1, rank2, rank3];

export interface RankItemProps {
  rank: number;
  avatar?: string;
  nickname: string;
  bonusScore: number;
  rewardAmount: number;
}

export default function RankItem({
  rank,
  avatar,
  nickname,
  bonusScore,
  rewardAmount,
}: RankItemProps) {
  return (
    <div className="relative z-10">
      <div
        className="bg-full w-full h-[3.0625rem] flex gap-3 items-center px-5"
        style={{
          backgroundImage: `url(${rank > 3 ? rankBg : rankbgList[rank - 1]})`,
        }}>
        <div className="flex gap-3 items-center flex-1 ">
          {rank > 3 ? (
            <div
              className="text-[#F6D689] text-base text-center font-extrabold w-6"
              style={{
                textShadow: '0 4px 8px rgba(0, 0, 0, 0.43)',
              }}>
              {rank}
            </div>
          ) : (
            <div className="size-6 flex items-center justify-center">
              <div
                className="size-5"
                style={{
                  backgroundImage: `url(${rankIconList[rank - 1]})`,
                  backgroundSize: 'cover',
                }}></div>
            </div>
          )}

          <div className="size-[2.125rem] border-2 border-[#ffeaa7] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.2)] rounded-full flex-shrink-0 overflow-hidden">
            <div
              className="bg-full size-full"
              style={{
                backgroundImage: `url(${avatar || defaultUser})`,
              }}></div>
          </div>
          <div className="flex flex-1">
            <div>
              <div className="text-white text-xs font-medium">{nickname}</div>
              <div className="flex gap-1 items-center">
                <Image src={bounsIcon} className="size-3"></Image>
                <div className="text-xs font-semibold text-stroke-gold">
                  {toPriceStr(bonusScore, {
                    showCurrency: false,
                    suffixUnit: 'K',
                    fixed: 0,
                  })}
                </div>
              </div>
            </div>
            <div className="flex gap-1 ml-auto items-center">
              <Image src={priceIcon} className="w-[0.8125rem] h-[0.875rem]" />
              <div className="text-xs font-bold text-stroke-gold">
                {toPriceStr(rewardAmount, {
                  showCurrency: false,
                  suffixUnit: 'K',
                  fixed: 2,
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
